import { render, staticRenderFns } from "./richSelect.vue?vue&type=template&id=04dde16c&scoped=true&"
import script from "./richSelect.vue?vue&type=script&lang=js&"
export * from "./richSelect.vue?vue&type=script&lang=js&"
import style0 from "./richSelect.vue?vue&type=style&index=0&id=04dde16c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dde16c",
  null
  
)

export default component.exports